import { useState } from "react";
import Modal from "../../../utils/components/Modal";
import SelectBox from "../../../utils/components/SelectBox";
import API from "../../../utils/API";
import toastr from "toastr";
import timeStampToDateFormat from "../../../utils/helpers/timestampToDateFormat";

const WorkflowTaskCancelModal = ({
  show,
  hideModal,
  statusSets,
  dueDate,
  taskId,
  translate,
  formName,
  formNo,
}) => {
  const [isSending, setIsSending] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handleAction = () => {
    if (taskId === undefined || selectedStatus === null) {
      toastr.warning(translate("forms.status_empty_alert"));
      return;
    }

    setIsSending(true);

    const payload = {
      form_status: selectedStatus.label,
      task_id: taskId,
    };

    API.postData("workflow/cancel", payload)
      .then(({ data: res }) => {
        toastr.success(res.message);
        hideModal();
      })
      .catch((err) => {
        toastr.error(err.data.message);
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <div>
      <Modal
        title={translate("tasks.workflow_task_cancel.title")}
        positiveButtonNode={translate("send")}
        negativeButtonNode={translate("cancel")}
        positiveButtonHandler={handleAction}
        modalSize="lg"
        show={show}
        setShow={hideModal}
        disableButtons={isSending}
      >
        <div className="row">
          <div className="col-12">
            <p className="fw-bold fs-6 text-uppercase text-secondary text-end mb-2">
              {translate("tasks.task_no")} : {taskId}
            </p>
          </div>
          <div className="col-12 mt-2 text-center">
            <p className="text-orange fs-3">{formNo}</p>
            <p className="text-secondary fs-6">{formName}</p>
          </div>
          {/*           <div className="col-12 mt-2 mb-4 text-center">
            <p className="fw-bold fs-6 text-uppercase text-secondary mt-4 mb-0">
              Görev Atanan
            </p>
            <div className="mt-2">
              {[1, 2, 3, 4, 5].map((item, index) => (
                <span
                  className="badge bg-secondary text-center py-1 px-2 me-3 mb-2"
                  key={index}
                >
                  Ozan Küçük, Penguen
                </span>
              ))}
            </div>
          </div>
          <div className="col-12 mb-4 text-center">
            <p className="fw-bold fs-6 text-uppercase text-secondary mt-3 mb-0">
              Bilgi için
            </p>
            <div className="mt-2">
              {[1, 2, 3, 4].map((item, index) => (
                <span
                  className="badge bg-secondary text-center py-1 px-2 me-3 mb-2"
                  key={index}
                >
                  Elif Orman, TAV
                </span>
              ))}
            </div>
          </div> */}
          <div className="col-12 my-5 text-center">
            <p className="fw-bold fs-6 text-uppercase text-secondary mb-0">
              Bitiş Tarihi: {timeStampToDateFormat(dueDate, "dd/MM/yyyy")}
            </p>
          </div>
          <div className="col-11 ms-3 border border-2 rounded pt-4 pb-2 mb-4">
            <p className="ps-2 text-secondary">
              {translate("tasks.workflow_task_cancel.description")}:
            </p>
            {[1, 2, 3, 4].map((item) => (
              <p className="ps-4 text-secondary" key={item}>
                {item}.{" "}
                {translate(`tasks.workflow_task_cancel.cancel_result_${item}`)}
              </p>
            ))}
          </div>
          <div className="col-10 my-5 ms-5">
            <p>{translate("forms.place-holders.select-status")}</p>
            <SelectBox
              options={statusSets}
              placeholder={translate("please_select")}
              value={selectedStatus}
              onChange={(selectedStatus) => setSelectedStatus(selectedStatus)}
            ></SelectBox>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WorkflowTaskCancelModal;
